<ul class="menu">
    <li routerLink="reporting/sector" matTooltip="Home" [matTooltipPosition]="'right'">
        <img class="logo" src="assets/main/be-logo.svg" alt="Baltic Exchange Logo" title="Baltic Exchange" />
        <h1>Baltic Exchange: Error Free Rate</h1>
    </li>
</ul>
<app-session></app-session>